<template>
  <div>
    <h3 class="text-2xl max-w-2xl text-vice-teal-900 font-semibold leading-tight">
      Session duration & totals
    </h3>

    <div class="relative overflow-x-auto shadow-md border rounded-lg mt-5 mb-10">
      <table class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead
          class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
        >
          <tr>
            <th scope="col" class="px-6 py-3">Total duration</th>
            <th scope="col" class="px-6 py-3">Intro</th>
            <th scope="col" class="px-6 py-3">Consult</th>
            <th scope="col" class="px-6 py-3">Debrief</th>
          </tr>
        </thead>
        <tbody>
          <tr class="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
            <th
              scope="row"
              class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
            >
              {{ durationData.total_raw }}
            </th>
            <td class="px-6 py-4 whitespace-nowrap">{{ durationData.introduction }}</td>
            <td class="px-6 py-4 whitespace-nowrap">{{ durationData.consultation }}</td>
            <td class="px-6 py-4 whitespace-nowrap">{{ durationData.debrief }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
// import VueApexCharts from 'vue3-apexcharts';

export default {
  name: 'SessionDurationAndTotals',
  props: {
    durationData: {
      require: true,
    },
  },
};
</script>

<style scoped></style>
